import * as React from 'react';
import { DistributionOptionsContainer } from '../../../../containers/audience/DistributionOptionsPage';
import { AudienceLoaderContainer } from '../../../../containers/pages/AudienceLoaderContainer';
import { AudiencePageStateSetterRouteProps } from '../../../../containers/state-setter/AudiencePageStateSetterBase';
import { DistributionOptionsPageStateSetter } from '../../../../containers/state-setter/DistributionOptionsPageStateSetter';
import { AudienceMode } from '../../../audiences/AudienceMode';

export class DistributionOptionsAdminPage extends React.PureComponent<AudiencePageStateSetterRouteProps> {
	public render() {
		const surveyId = parseInt(this.props.match.params.surveyId, 10);

		return (
			<>
				<AudienceLoaderContainer surveyId={surveyId} />
				<DistributionOptionsContainer {...this.props} mode={AudienceMode.Admin} />
				<DistributionOptionsPageStateSetter {...this.props} />
			</>
		);
	}
}
